import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { CardComp, ButtonComp } from "..";
import { formatMoney } from "../../utils/currencyFormat";
import RiskBadge from "./RiskBadge";
import FundingProgress from "./FundingProgress";
import { investorButtonProps } from "./investorButtonStyles";
import { isInvestable } from "../../utils/investorInvestmentsAdapter";

const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;

  .category-badge {
    background: var(--color-secondary);
    color: #fff;
    font-size: 11px;
    font-weight: 600;
  }

  .card-title {
    color: #383838;
    font-size: 1.05rem;
    line-height: 1.35;
  }

  .metric-label {
    font-size: 0.75rem;
    color: #525252;
  }

  .metric-value {
    font-size: 0.9rem;
    font-weight: 600;
    color: #383838;
  }

  .card-actions {
    margin-top: auto;
    padding-top: 1rem;
  }
`;

export default function InvestmentCard({ opportunity, onInvest }) {
  const navigate = useNavigate();
  const fundedPct = Math.round(
    ((opportunity.totalUnits - opportunity.availableUnits) / opportunity.totalUnits) * 100
  );

  return (
    <CardComp cardClassName="border-0 shadow-sm rounded-4 h-100 investor-investment-card" data-tour="invest-opps-card">
      <CardInner>
        <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
          <span className="badge rounded-pill category-badge">{opportunity.category}</span>
          <RiskBadge level={opportunity.riskLevel} />
        </div>
        <h5 className="fw-bold card-title mb-2">{opportunity.name}</h5>
        <p className="text-muted small flex-grow-1 mb-3" style={{ lineHeight: 1.5 }}>
          {opportunity.description}
        </p>
        <div className="row g-3 mb-3">
          <div className="col-6">
            <span className="metric-label d-block mb-1">Unit price</span>
            <span className="metric-value">{formatMoney(opportunity.unitPriceNgn)}</span>
          </div>
          <div className="col-6">
            <span className="metric-label d-block mb-1">Expected return</span>
            <span className="metric-value">
              {opportunity.expectedReturnPct}% · {opportunity.durationMonths}mo
            </span>
          </div>
        </div>
        <FundingProgress percent={fundedPct} />
        <div className="card-actions d-flex flex-column flex-sm-row gap-2">
          <ButtonComp
            btnText="View details"
            btnClassName="flex-fill"
            containerClassName="flex-fill"
            onClick={() => navigate(`/invest/investments/${opportunity.id}`)}
            {...investorButtonProps.secondary}
            ButtonInlineStyle={{ ...investorButtonProps.secondary.ButtonInlineStyle, width: "100%" }}
          />
          {isInvestable(opportunity) ? (
            <ButtonComp
              btnText="Invest"
              btnClassName="flex-fill"
              containerClassName="flex-fill"
              onClick={() => onInvest?.(opportunity)}
              {...investorButtonProps.primary}
              ButtonInlineStyle={{ ...investorButtonProps.primary.ButtonInlineStyle, width: "100%" }}
            />
          ) : null}
        </div>
        {!isInvestable(opportunity) && opportunity.investUnavailableReason ? (
          <p className="small text-muted mb-0 mt-2">{opportunity.investUnavailableReason}</p>
        ) : null}
      </CardInner>
    </CardComp>
  );
}
